import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {NavList} from '../../shared/models/navlist.model';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {NavService} from '../../shared/services/nav.service';
import {Router} from '@angular/router';
import * as UIC from '@dds-uicore/all';
import { AuthService } from 'src/app/shared/services/auth.service';
import { GlobalConstants } from 'src/app/shared/global-constants';
import { CommonService } from 'src/app/shared/services/common.service';
@Component({
  selector: 'app-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.scss'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({transform: 'rotate(0deg)'})),
      state('expanded', style({transform: 'rotate(180deg)'})),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ])
  ]
})
export class MenuListItemComponent implements OnInit {
  expanded: boolean = false;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item: NavList;
  @Input() depth: number;
  RoleName:string;
  Moderator = GlobalConstants.Moderator;
  Publisher = GlobalConstants.Publisher;
  dloUser = GlobalConstants.dloUser;
  Drafted = GlobalConstants.Drafted;
  Published = GlobalConstants.Published;
  PendingApproval = GlobalConstants.PendingApproval;
  Deleted = GlobalConstants.Deleted;
  Rejected = GlobalConstants.Rejected;
  Public = GlobalConstants.Public;
  Restricted = GlobalConstants.Restricted;

  constructor(private authService:AuthService,private commonService:CommonService, private navService:NavService,public router:Router) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
 }
  ngOnInit() {
    this.authService.itemValue.subscribe((nextValue) => {
      this.RoleName=nextValue.RoleName;

    });
    // this.RoleName=localStorage.getItem('RoleName');
    [].forEach.call(document.querySelectorAll("[data-toggle=\"dds__tooltip\"]"), function(element) { new UIC.Tooltip(element); });

    //expansion
    this.navService.currentUrl.subscribe((url: string) => {
      url=url && url.toLowerCase();
      if (this.item.route && url) {
        this.expanded = url.indexOf(`/${this.item.route.toLowerCase()}/`) === 0;
        this.ariaExpanded = this.expanded;
      }
    });
  }
  trimName(name:string){
    if(name.length <= 13)
      return name;
    else
      return name.substring(0,11) + '..'
  }
  onIconClick(type,item){
    if(item.active && type !='restore'){this.navService.triggerFunction(type,item);}
    if(!item.active && type =='restore'){this.navService.triggerFunction(type,item);}

  }
  onItemSelected(item: NavList) {
    if (!item.children || !item.children.length) {
      // this.router.navigate([item.route]);
      if(!item.id || item.articleID || (item.active && item.id)){
        this.authService.setPreviousRoute('portal');
        this.router.navigate([item.route]);
      }
      else if(!item.active && !item.articleID  && item.type.toLowerCase() != "folder"){
        this.commonService.setNotification("Empty file which is deleted cannot be openend. Please restore to proceed","Error")
      }
      this.navService.closeNav();
    }
    if (item.children && item.children.length) {

      this.expanded = !this.expanded;
    }
  }
}
